"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IntersectionDetector_1 = require("./IntersectionDetector");
var ScrollThroughViewportDetector_1 = __importDefault(require("./ScrollThroughViewportDetector"));
function ScrollThroughIntersectionDetector(props) {
    var onScrollThrough = props.onScrollThrough, offset = props.offset;
    var intersectionDetector = react_1.default.createElement(IntersectionDetector_1.IntersectionDetector, { onIntersect: onScrollThrough, rootMargin: offset ? "".concat(offset.toString(), "px") : undefined });
    // fall back to ScrollThroughViewportDetector with scroll event listener
    if (typeof IntersectionObserver === 'undefined') {
        console.warn('IntersectionObserver is undefined');
        intersectionDetector = react_1.default.createElement(ScrollThroughViewportDetector_1.default, { onScrollThrough: onScrollThrough, offset: offset });
    }
    return intersectionDetector;
}
exports.default = ScrollThroughIntersectionDetector;
